import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerDialogService } from '../dialogs/customer/customer.service.dialog';
import { ItemSearchDialogService } from '../dialogs/item-search/item-search.service.dialog';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { LineItem } from '@contracts/interfaces/lineitem.interface';
import { InvoicesService } from '../services/invoices.service';
import { CustomerService } from '../services/customer.service';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';

@Component({
  selector: 'app-invoice',
  template: `Invoice Works!`,
  styleUrls: []
})
export class InvoiceComponent implements OnChanges {
  displayedColumns: string[] = ['item', 'desc', 'qty', 'price', 'actions'];
  invoiceItemsDataSource: MatTableDataSource<LineItem>;

  @Input() 
  public invoice: InvoiceInterface;
  @Input()
  public prefillCustomer: CustomerInterface | null = null;
  @Input()
  public prefillLineDescription: string | null = null;
  @Input()
  public prefillLineItemsInput: LineItem[] | null = null;
  public prefillLineItems: LineItem[] = [];

  public defaultInvoice = {
    type: "standard",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: "invoice-standard"
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0
      }
    ],
    gst: 0,
    isGSTIncluded: false,
    communicationLog: []
  }


  @Output() invoiceSaved = new EventEmitter();

  isOpen = false;

  editMode = false;

  constructor(
    public changeDetectorRefs: ChangeDetectorRef,
    public router: Router,
    private route: ActivatedRoute,
    public invoicesService: InvoicesService,
    public customerDialogService: CustomerDialogService,
    public itemSearchDialogService: ItemSearchDialogService,
    public customerService: CustomerService) { }

  ngOnInit(): void {

    const date = new Date();
    // Load existing invoice
    if (this.invoice != undefined) {

      this.reloadInvoiceTables();
      this.editMode = true;

    // Generate new invoice
    } else {
      const base = this.defaultInvoice;
      this.invoice = {
        ...base,
        dateCreated: new Date(),
        dateDue: new Date(),
        paymentsMade: [],
        lineItems: [],
        communicationLog: []
      };
      if (this.prefillCustomer) {
        this.invoice.customer = this.prefillCustomer;
      }
      this.invoice.lineItems = this.buildInitialLineItems();
      this.reloadInvoiceTables();

      date.setDate(date.getDate() + 7);
      date.setHours(9, 0, 0);
      this.invoice.dateDue = date;

      this.invoicesService.getAvailableInvoiceNumber().subscribe((r:any)=> {
        this.invoice.number = r.number;
      });
    }
    this.childOnInit();
  }

  childOnInit(){}

  addLineItem() {

    this.invoice.lineItems.push({
      item: "",
      desc: "",
      qty: 1,
      price: 0
    });

    this.reloadInvoiceTables();
  }

  deleteLineItem(index) {
    this.invoice.lineItems.splice(index, 1)

    this.reloadInvoiceTables();
  }

  amountChanged(amount: number, index: number) {
    this.invoice.lineItems[index].price = amount;
    this.reloadInvoiceTables()
  }

  reloadInvoiceTables() {

    if (this.invoice.lineItems == undefined) {
      this.invoice.lineItems = [];
    }

    if (this.invoice.lineItems.length == 0) {
      this.invoice.lineItems.push({
        item: "",
        desc: "",
        price: 0,
        qty: 1,
      })
    }


    this.invoice = this.invoicesService.validate(this.invoice);

    this.invoiceItemsDataSource = new MatTableDataSource(this.invoice.lineItems);
    this.invoiceItemsDataSource._updateChangeSubscription();

    //this.save();
  }

  save() {

    this.invoice = this.invoicesService.validate(this.invoice);

    // When creating new invoice
    if (!this.editMode) {
      
      // Get a invoice number
      this.invoicesService.getAvailableInvoiceNumber().subscribe((r: any) => {
        this.invoice.number = r.number;

        // Create invoice
        this.invoicesService.create(this.invoice).subscribe((r:any) => {
          this.editMode = true;
          console.log(r.invoice)
          this.invoiceSaved.emit(r.invoice);
        });
      })

    // When creating a new invoice
    } else {

      // Update existing invoice
      this.invoicesService.updateOne(this.invoice).subscribe((r:any)=> {
        this.invoiceSaved.emit(r.invoice);
      })
    }
  }

  updateCustomer(customer: any) {
    this.invoice.customer = customer;
  }

  check () {
    console.log(this.invoice);
  }

  private buildInitialLineItems(): LineItem[] {
    if (this.prefillLineItemsInput && this.prefillLineItemsInput.length > 0) {
      return this.sanitiseLineItems(this.prefillLineItemsInput);
    }

    if (this.prefillLineDescription) {
      return [{
        item: 'Service',
        desc: this.prefillLineDescription,
        qty: 1,
        price: 0
      }];
    }

    return this.defaultInvoice.lineItems.map(li => ({...li}));
  }

  private sanitiseLineItems(items: LineItem[]): LineItem[] {
    const cleaned = items
      .map(li => ({
        item: li.item || 'Service',
        desc: li.desc || '',
        qty: Number(li.qty) || 1,
        price: Number(li.price) || 0,
        sku: li.sku ?? null,
        deducted: li.deducted ?? false
      }))
      .filter(li => !!li.desc);

    if (!cleaned.length) {
      cleaned.push({
        item: 'Service',
        desc: this.prefillLineDescription ?? '',
        qty: 1,
        price: 0,
        sku: '',
        deducted: false
      });
    }

    return cleaned;
  }

  findLineItem(index: number) {
    this.invoicesService.openLineItemFindDialog(this.prefillLineItems, (selectedLineItem: LineItem) => {
      if (selectedLineItem != undefined) {
        this.invoice.lineItems[index] = selectedLineItem;
        this.invoice = this.invoicesService.validate(this.invoice);
        this.invoiceItemsDataSource._updateChangeSubscription();
      }
    })
  }

  afterFirstLoad = false;
  ngOnChanges() {
    if (this.afterFirstLoad) {
      this.ngOnInit();
    } else {
      this.afterFirstLoad = true;
    }
  }
}
